import Nav from "../_nav/_nav.js";

class Language {
	/**
	 * @param {HTMLElement} element
	 * @param {() => void} [callback]
	 */
	constructor(element, callback) {
		this.element = element;
		this.callback = callback;

		const nav = element.querySelector(".SideNavLanguage-nav");

		if (nav) {
			this.nav = new Nav(nav);
		}
	}
}

export default Language;
